import { Typography } from '@euler/app/components/typography';
import Euler from '@euler/components/layout';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useCallback, useState } from 'react';
import DateTimePickerModal, {
  DateTimePickerProps,
} from 'react-native-modal-datetime-picker';

export const useDateTimePicker = () => {
  const [show, setShow] = useState(false);
  const showDateTimePicker = useCallback(() => {
    setShow(true);
  }, []);
  const hideDateTimePicker = useCallback(() => {
    setShow(false);
  }, []);
  return [show, showDateTimePicker, hideDateTimePicker] as const;
};

type Props = DateTimePickerProps & {
  title?: string;
};

export const DateTimePicker = memo(({ title, ...props }: Props) => {
  const { rpx } = useResponsiveContext();
  const Header = useCallback(() => {
    if (!title) return null;
    return (
      <Euler.View pt={rpx(15)} pb={rpx(5)}>
        <Typography.Text
          align="center"
          family="medium"
          color="#333"
          size={rpx(18)}
        >
          {title}
        </Typography.Text>
      </Euler.View>
    );
  }, [rpx, title]);
  return (
    <DateTimePickerModal locale="zh-CN" {...props} customHeaderIOS={Header} />
  );
});
